import PageProtected from "../../../../components/Page/PageProtected";
import SectionDashboard from "../../../../components/Section/SectionDashboard";
import SectionVariantPatho from "./Sections/SectionVariantPatho";
import SectionDisclaimer from "../../../../components/Disclaimer/SectionDisclaimer";
import DisclaimerCard from "./DisclaimerCard";


import { useTheme } from "@mui/material";

export default function GeneticsWelcome() {

    const theme = useTheme();

return (
<>
    


    <PageProtected
    
    headline="GENETICS - " 
    specify ="HEREDITARY DISEASE RISK"

    main={<> 

    {theme.palette.mode === "light" ? (

        <SectionDashboard

            colorContainer="transparent"

            colorSection_1="grey.C300"
            Section_1={<SectionVariantPatho />}

            colorSection_2="grey.C100"
            Section_2={ <SectionDisclaimer disclaimer={<DisclaimerCard />} />  }
            
            colorSection_3="grey.C100"
            Section_3= {""  } 

            colorSection_4="primary.C200"
            Section_4={ "" }

        />

):(

    <SectionDashboard

            colorContainer="transparent"

            colorSection_1="greydark.C900"
            Section_1={ <SectionVariantPatho />}

            colorSection_2="greydark.C800"
            Section_2={  <SectionDisclaimer disclaimer={<DisclaimerCard />} />  }
            
            colorSection_3="grey.C100"
            Section_3= {""  }  

            colorSection_4="secondarydark.C200"
            Section_4={ "" }

        />
        )}
    </>
    }
/>

</>
)
}